import styles from "../address-auto-suggest.module.scss";

export default function RegistrySuggestionItem({ suggestion }) {
  const {
    registryAddress: { fullAddress },
  } = suggestion;
  return <div className={styles.suggestion_item_inner}>{fullAddress}</div>;
}
